export const nextId = function () {
  return (Math.random() * 1e10 + new Date().getTime()).toString(32).slice(0, 8);
}

export const hasText = function (text) {
  return typeof text === 'string' && text.length > 0;
}
